import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CircularProgress, Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { useAccount, useChainId } from 'wagmi';
import axios from 'axios';
import { getConnections, waitForTransactionReceipt } from '@wagmi/core';
import Web3 from 'web3';
import BigNumber from 'bignumber.js';
import {
  MdOutlineErrorOutline,
  MdOutlineKeyboardArrowDown,
} from 'react-icons/md';
import { BrowserProvider, L1Signer, Provider, Signer } from 'zksync-ethers';

import OZKToken from '../../../ContractABI/OPENZKToken.json';
import DAIToken from '../../../ContractABI/DAIToken.json';
import USDTToken from '../../../ContractABI/USDTToken.json';
import USDCToken from '../../../ContractABI/USDCToken.json';
import bridgeWrapper from '../../../ContractABI/BridgeWrapper.json';

import ETHLOGO from '../../../Assets/images/Icons/Ethreum.svg';
import USDCLogo from '../../../Assets/images/Icons/USDC.svg';
import USDTLogo from '../../../Assets/images/Icons/USDT.svg';
import DAILOGO from '../../../Assets/images/Icons/DAILogo.png';
import OZKLogo from '../../../Assets/images/Icons/OZKLogo.png';
import ozETHLogo from '../../../Assets/images/Icons/ozETH.svg';
import ozUSDLogo from '../../../Assets/images/Icons/ozUSD.svg';
import DoubleArrow from '../../../Assets/images/double-arrow.png';
import ConnectButton from '../../../WagmiProvider/ConnectButton';
import {
  REACT_APP_BLOCK_EXPLORER_OPEN_ZK_URL,
  REACT_APP_BRIDGE_CONTRACT_WRAPPER,
  REACT_APP_CHAIN_ID,
  REACT_APP_DAI_PERCENTAGE_COMMISSION,
  REACT_APP_DAI_TOKEN,
  REACT_APP_ETH_PERCENTAGE_COMMISSION,
  REACT_APP_ETH_RPC,
  REACT_APP_ETH_TRANSACTION,
  REACT_APP_OPENZK_CHAIN_ID,
  REACT_APP_OPENZK_RPC,
  REACT_APP_OZK_TOKEN,
  REACT_APP_OZUSD_L2_TOKEN,
  REACT_APP_USDT_TOKEN,
  REACT_APP_USDT_USDC_PERCENTAGE_COMMISSION,
  REACT_APP_USDC_TOKEN,
  REACT_APP_OZUSD_L2_WITHDRAW_CONTRACT,
} from '../../../Config/Config';
import { toast } from 'react-toastify';
import CustomModal from '../../../Components/Modal/CustomModal';
import { CiWallet } from 'react-icons/ci';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import GradiantButton from '../../../Components/Button/GradiantButton';
import { isDisabled } from '../../../utils/constants';

import { wagmiAdapterConfig } from '../../../Config/WagmiConfig';
import { AppConfig } from '../../../Config/app-config';
import { useBalance } from '../../../hooks/useBalance';
import { Status, useL2Transactions } from '../../../hooks/useL2Transactions';
import { useWalletChain } from '../../../hooks/useWalletChain';
import { WalletConnectModal } from '../modals/walletConnectModal';

const Bridge = () => {
  const { isConnected, address, chain } = useAccount();
  const chainId = useChainId();
  const {
    loadL1Balance,
    loadL2Balance,
    usdtBalance,
    usdcBalance,
    ethBalance,
    daiBalance,
    ozEthBalance,
    ozUsdBalance,
    resetL1Balance,
    resetL2Balance,
    resetWithdrawBalance,
  } = useBalance();
  const [isChecked, setIsChecked] = useState(false);
  let usedAddresses = JSON.parse(localStorage.getItem('usedWallets')) || [];

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const { loadL2Transactions, transactions, loading, resetTransactions } =
    useL2Transactions(address);

  const connections = getConnections(wagmiAdapterConfig);
  const { addOZKChain, addEthereumChain, error } = useWalletChain();

  const [bridgeValue, setBridgeValue] = useState('');
  const [bridgeAmountWithCommission, setBridgeAmountWithCommission] =
    useState('');
  const [selectToken, setSelectToken] = useState(false);
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [openBridgeModal, setOpenBridgeModal] = useState(false);
  const [bridgeStatus, setBridgeStatus] = useState('Waiting');
  const [walletAction, setWalletAction] = useState(
    'Stake and Bridge is underway',
  );
  const [isClaim, setIsClaim] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [isEthereumL1, setIsEthereumL1] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorAction, setErrorAction] = useState('');
  const [txHash, setTxHash] = useState('');
  const [txHashL2, setTxHashL2] = useState('');
  const [walletConnectModal, setWalletConnectModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedToken, setSelectedToken] = useState({
    Token: 'OZK',
    value: 0.0,
    logo: ETHLOGO,
    symbol: 'ETH',
    contract: REACT_APP_OZK_TOKEN,
    receiveToken: 'ozETH',
  });

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });

  const formatterEth = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  });

  const TokenL1Options = [
    {
      Token: 'ETH',
      value: 0.0,
      logo: ETHLOGO,
      symbol: 'ETH',
      contract: REACT_APP_OZK_TOKEN,
      receiveToken: 'ozETH',
    },
    {
      Token: 'DAI',
      value: 0.0,
      logo: DAILOGO,
      symbol: 'DAI',
      contract: REACT_APP_DAI_TOKEN,
      receiveToken: 'ozUSD',
    },
    {
      Token: 'USDC',
      value: 0.0,
      logo: USDCLogo,
      symbol: 'USDC',
      contract: REACT_APP_USDC_TOKEN,
      receiveToken: 'ozUSD',
    },
    {
      Token: 'USDT',
      value: 0.0,
      logo: USDTLogo,
      symbol: 'USDT',
      contract: REACT_APP_USDT_TOKEN,
      receiveToken: 'ozUSD',
    },
  ];

  const TokenL2Options = [
    {
      Token: 'ozETH',
      value: 0.0,
      logo: ozETHLogo,
      symbol: 'ozETH',
      contract: REACT_APP_OZK_TOKEN,
      receiveToken: 'ozETH',
    },

    {
      Token: 'ozUSD',
      value: 0.0,
      logo: ozUSDLogo,
      symbol: 'ozUSD',
      contract: REACT_APP_USDT_TOKEN,
      receiveToken: 'ozUSD',
    },
  ];

  const TokenOptions = useMemo(() => {
    if (isEthereumL1) {
      return TokenL1Options;
    }
    return TokenL2Options;
  }, [isEthereumL1]);

  const L1 = {
    text: 'Ethereum (Layer 1)',
    icon: ETHLOGO,
    name: 'ETH',
  };

  const L2 = {
    text: 'OpenZK (Layer 2)',
    icon: OZKLogo,
    name: 'OZK',
  };

  const isWalletConnect = useMemo(
    () =>
      connections &&
      connections.length > 0 &&
      connections[0].connector.id === 'walletConnect',
    [connections],
  );

  const handleSelectDepositToken = async (itm) => {
    setSelectedToken(itm);
    setBridgeValue('');
    setBridgeAmountWithCommission('');
    setSelectToken(false);
  };

  const HandleDepositInput = async (value) => {
    if (value === '') {
      setBridgeAmountWithCommission('');
      setBridgeValue('0');
      return;
    }
    if (selectedToken?.symbol === 'ETH') {
      if (Number(value) < Number(ethBalance)) {
        if (value.length < 10) {
          setBridgeValue(value);
          const valueWithCommission = BigNumber(value).multipliedBy(
            BigNumber(REACT_APP_ETH_PERCENTAGE_COMMISSION),
          );
          setBridgeAmountWithCommission(valueWithCommission.toString());
        }
      }
    } else if (selectedToken?.symbol === 'DAI') {
      if (Number(value) < Number(daiBalance)) {
        if (value.length < 10) {
          setBridgeValue(value);
          const valueWithCommission = BigNumber(value).multipliedBy(
            BigNumber(REACT_APP_DAI_PERCENTAGE_COMMISSION),
          );
          setBridgeAmountWithCommission(valueWithCommission.toString());
        }
      }
    } else if (selectedToken?.symbol === 'USDC') {
      if (Number(value) < Number(usdcBalance)) {
        if (value.length < 10) {
          setBridgeValue(value);
          const valueWithCommission = BigNumber(value).multipliedBy(
            BigNumber(REACT_APP_USDT_USDC_PERCENTAGE_COMMISSION),
          );
          setBridgeAmountWithCommission(valueWithCommission.toString());
        }
      }
    } else if (selectedToken?.symbol === 'USDT') {
      if (Number(value) < Number(usdtBalance)) {
        if (value.length < 10) {
          setBridgeValue(value);
          const valueWithCommission = BigNumber(value).multipliedBy(
            BigNumber(REACT_APP_USDT_USDC_PERCENTAGE_COMMISSION),
          );
          setBridgeAmountWithCommission(valueWithCommission.toString());
        }
      }
    } else if (selectedToken?.symbol === 'ozUSD') {
      if (Number(value) < Number(ozUsdBalance)) {
        if (value.length < 10) {
          setBridgeValue(value);
          setBridgeAmountWithCommission(value);
        }
      }
    } else if (selectedToken?.symbol === 'ozETH') {
      if (Number(value) < Number(ozEthBalance)) {
        if (value.length < 10) {
          setBridgeValue(value);
          const valueWithCommission = BigNumber(value).multipliedBy(
            BigNumber(REACT_APP_ETH_PERCENTAGE_COMMISSION),
          );
          setBridgeAmountWithCommission(valueWithCommission.toString());
        }
      }
    }
  };

  const handleBridgeL1Token = async () => {
    setErrorMessage('');
    setErrorAction('');
    setTxHashL2('');
    setTxHash('');
    setIsClaim(false);

    if (!isChecked) {
      toast.warn('You must agree to our Terms and Conditions');
      const section = document.getElementById('agreeTcId');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }

    if (!connections || connections.length === 0) {
      toast.warn('No wallet connector found');
      return;
    }

    const walletProvider = await connections[0].connector.getProvider();

    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }

    if (!usedAddresses.includes(address)) {
      setOpen(true);
      usedAddresses.push(address);
      localStorage.setItem('usedWallets', JSON.stringify(usedAddresses));
      return;
    }

    const web3 = new Web3(walletProvider);
    if (!bridgeValue || bridgeValue.trim().length === 0) {
      toast.warn('Enter Deposit Amount');
      return;
    }
    if (Number(bridgeValue) <= 0) {
      toast.warn('Deposit Amount must be greater than zero');
      return;
    }
    if (chainId !== REACT_APP_CHAIN_ID) {
      toast.warn(
        `Switch Your Network To ${AppConfig.isDev ? 'Sepolia testnet' : 'Ethereum Mainnet'}`,
      );
      return;
    }

    if (selectedToken?.symbol === 'DAI') {
      return await stakeAndBridgeStable(bridgeValue, web3, DAIToken);
    }

    if (selectedToken?.symbol === 'USDC') {
      return await stakeAndBridgeStable(bridgeValue, web3, USDCToken);
    }

    if (selectedToken?.symbol === 'USDT') {
      return await stakeAndBridgeStable(bridgeValue, web3, USDTToken);
    }

    if (selectedToken?.symbol === 'ETH') {
      return await stakeAndBridgeEth(bridgeValue, web3);
    }
  };

  const handleBridgeL2Token = async () => {
    setErrorMessage('');
    setErrorAction('');
    setTxHashL2('');
    setTxHash('');
    setIsClaim(false);

    if (!isChecked) {
      toast.warn('You must agree to our Terms and Conditions');
      return;
    }

    if (!connections || connections.length === 0) {
      toast.warn('No wallet connector found');
      return;
    }

    const walletProvider = await connections[0].connector.getProvider();

    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }

    const web3 = new Web3(walletProvider);
    if (!bridgeValue || bridgeValue.trim().length === 0) {
      toast.warn('Enter Deposit Amount');
      return;
    }
    if (Number(bridgeValue) <= 0) {
      toast.warn('Deposit Amount must be greater than zero');
      return;
    }
    if (chainId !== REACT_APP_OPENZK_CHAIN_ID) {
      toast.warn('Switch Your Network To OZK');
      return;
    }

    const provider = new BrowserProvider(walletProvider);

    const zkProvider = new Provider(REACT_APP_OPENZK_RPC);

    const signerL2 = Signer.from(
      await provider.getSigner(),
      Number((await provider.getNetwork()).chainId),
      zkProvider,
    );

    if (selectedToken?.symbol === 'ozETH') {
      return await BridgeL2Eth(bridgeValue, signerL2, web3);
    }

    if (selectedToken?.symbol === 'ozUSD') {
      return await BridgeL2USD(bridgeValue, web3);
    }
  };

  const BridgeL2Eth = async (bridgeValue, signer, web3) => {
    const bridgeAmount = web3.utils.toWei(bridgeValue, 'ether');
    setOpenBridgeModal(true);
    setBridgeStatus('Loading');
    setWalletAction('Bridge from L2 is loading');

    try {
      const nonce = await signer.getNonce();
      const tx = await signer.withdraw({
        amount: bridgeAmount,
        overrides: {
          nonce,
        },
      });

      try {
        await waitForTransactionReceipt(wagmiAdapterConfig, {
          confirmation: 1,
          hash: tx.hash,
        });
      } catch (error) {
        setErrorMessage(error.shortMessage);
        setErrorAction(error.action);
        setIsCompleted(false);
        setBridgeStatus('Error');
        return;
      }

      setTxHashL2(tx.hash);
      setIsCompleted(true);
      setBridgeStatus('Completed');
      loadL2Balance(address);
    } catch (error) {
      const regex = /"params": \[\s*"([^"]+)"/;
      const match = error.message.match(regex);

      if (match && error.code !== 'ACTION_REJECTED') {
        console.log('Extracted Value:', match[1]);
        try {
          const rawTx = match[1];

          const tx = await axios.post(REACT_APP_OPENZK_RPC, {
            jsonrpc: '2.0',
            method: 'eth_sendRawTransaction',
            params: [rawTx],
            id: 1,
          });

          if (tx && tx.data && tx.data.error && tx.data.error.code === 3) {
            setErrorMessage('Transaction failed');
            setErrorAction('Bridge from L2');
            setIsCompleted(false);
            setBridgeStatus('Error');
            return;
          }

          setTxHashL2(tx.data.result);
          setIsCompleted(true);
          setBridgeStatus('Completed');
          loadL2Balance(address);
        } catch (error) {
          console.log(error);
          setErrorMessage('Rejected transaction');
          setErrorAction('Bridge from L2');
          setIsCompleted(false);
          setBridgeStatus('Error');
        }
      } else {
        setErrorMessage('Rejected transaction');
        setErrorAction('Bridge from L2');
        setIsCompleted(false);
        setBridgeStatus('Error');
      }
    }
  };

  const BridgeL2USD = async (bridgeValue, web3) => {
    const bridgeAmount = web3.utils.toWei(bridgeValue, 'ether');
    setOpenBridgeModal(true);
    setBridgeStatus('Loading');
    setWalletAction('Bridge from L2 is loading');

    const BridgeABI = [
      {
        inputs: [
          { internalType: 'address', name: 'arg0', type: 'address' },
          { internalType: 'address', name: 'arg1', type: 'address' },
          { internalType: 'uint256', name: 'arg2', type: 'uint256' },
        ],
        name: 'withdraw',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
    ];

    const BridgeABIDev = [
      {
        inputs: [
          { internalType: 'uint256', name: 'arg0', type: 'uint256' },
          { internalType: 'address', name: 'arg1', type: 'address' },
          { internalType: 'address', name: 'arg2', type: 'address' },
        ],
        name: 'withdraw',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
      },
    ];

    const TokenContract = new web3.eth.Contract(
      AppConfig.isDev ? BridgeABIDev : BridgeABI,
      REACT_APP_OZUSD_L2_WITHDRAW_CONTRACT,
    );

    try {
      const tx = AppConfig.isDev
        ? await TokenContract.methods
            .withdraw(bridgeAmount, REACT_APP_OZUSD_L2_TOKEN, address)
            .send({ from: address })
        : await TokenContract.methods
            .withdraw(address, REACT_APP_OZUSD_L2_TOKEN, bridgeAmount)
            .send({ from: address });

      try {
        await waitForTransactionReceipt(wagmiAdapterConfig, {
          confirmation: 1,
          hash: tx.transactionHash,
        });
      } catch (error) {
        setErrorMessage(error.shortMessage);
        setErrorAction(error.action);
        setIsCompleted(false);
        setBridgeStatus('Error');
        return;
      }

      setTxHashL2(tx.transactionHash);
      setIsCompleted(true);
      setBridgeStatus('Completed');
      loadL2Balance(address);
    } catch (error) {
      console.log(error);
      const regex = /"params": \[\s*"([^"]+)"/;
      const match = error.message.match(regex);
      if (match) {
        console.log('Extracted Value:', match[1]);
        try {
          const rawTx = match[1];

          const tx = await axios.post(REACT_APP_OPENZK_RPC, {
            jsonrpc: '2.0',
            method: 'eth_sendRawTransaction',
            params: [rawTx],
            id: 1,
          });

          if (tx && tx.data && tx.data.error && tx.data.error.code === 3) {
            setErrorMessage('Transaction failed');
            setErrorAction('Bridge from L2');
            setIsCompleted(false);
            setBridgeStatus('Error');
            return;
          }

          setTxHashL2(tx.data.result);
          setIsCompleted(true);
          setBridgeStatus('Completed');
          loadL2Balance(address);
        } catch (error) {
          console.log(error);
          setErrorMessage('Rejected transaction');
          setErrorAction('Bridge from L2');
          setIsCompleted(false);
          setBridgeStatus('Error');
        }
      } else {
        console.log(error);
        setErrorMessage('Rejected transaction');
        setErrorAction('Bridge from L2');
        setIsCompleted(false);
        setBridgeStatus('Error');
      }
    }
  };

  const finalizeWithdrawal = useCallback(
    async (transactionHash) => {
      if (chainId !== REACT_APP_CHAIN_ID) {
        toast.warn('Switch Your Network To Ethereum');
        return;
      }
      try {
        setOpenBridgeModal(true);
        setBridgeStatus('Loading');
        setWalletAction('Claim bridge is loading');

        const walletProvider = await connections[0].connector.getProvider();

        if (!walletProvider) {
          toast.warn('Wallet provider not found');
          return;
        }

        const provider = new BrowserProvider(walletProvider);

        const zkProvider = new Provider(REACT_APP_OPENZK_RPC);

        const signer = L1Signer.from(await provider.getSigner(), zkProvider);

        const finalize = await signer.finalizeWithdrawal(transactionHash);

        await waitForTransactionReceipt(wagmiAdapterConfig, {
          confirmation: 1,
          hash: finalize.hash,
        });

        setTxHash(finalize.hash);
        setIsCompleted(true);
        setIsClaim(true);
        setBridgeStatus('Completed');
        setWalletAction('Claim bridge completed');
        loadL2Transactions(connections);
      } catch (error) {
        console.log(error);
        if (error?.shortMessage && error?.action) {
          setErrorMessage(error.shortMessage);
          setErrorAction(error.action);
        } else {
          setErrorMessage('Rejected transaction');
          setErrorAction('finalizeWithdrawal');
        }
        setIsCompleted(false);
        setBridgeStatus('Error');
      }
    },
    [chainId, connections],
  );

  const stakeAndBridgeStable = async (bridgeValue, web3, abi) => {
    const TokenContract = new web3.eth.Contract(abi, selectedToken.contract);
    const decimals = await TokenContract.methods.decimals().call();
    const bridgeAmount = (
      BigNumber(bridgeValue) * BigNumber(10).pow(decimals)
    ).toString();
    try {
      setOpenBridgeModal(true);
      setBridgeStatus('Loading');

      const allowance = await TokenContract.methods
        .allowance(address, REACT_APP_BRIDGE_CONTRACT_WRAPPER)
        .call();

      switch (selectedToken.symbol) {
        case 'USDT':
          if (BigNumber(allowance.toString()).isEqualTo(0)) {
            const approve = await TokenContract.methods
              .approve(REACT_APP_BRIDGE_CONTRACT_WRAPPER, bridgeAmount)
              .send({ from: address });

            await waitForTransactionReceipt(wagmiAdapterConfig, {
              confirmation: 1,
              hash: approve.transactionHash,
            });
          } else if (
            BigNumber(bridgeAmount).isGreaterThan(allowance.toString())
          ) {
            const approveToZero = await TokenContract.methods
              .approve(REACT_APP_BRIDGE_CONTRACT_WRAPPER, 0)
              .send({ from: address });

            await waitForTransactionReceipt(wagmiAdapterConfig, {
              confirmation: 1,
              hash: approveToZero.transactionHash,
            });

            const approve = await TokenContract.methods
              .approve(REACT_APP_BRIDGE_CONTRACT_WRAPPER, bridgeAmount)
              .send({ from: address });

            await waitForTransactionReceipt(wagmiAdapterConfig, {
              confirmation: 1,
              hash: approve.transactionHash,
            });
          }
          break;
        case 'USDC':
          if (BigNumber(bridgeAmount).isGreaterThan(allowance.toString())) {
            const approve = await TokenContract.methods
              .approve(REACT_APP_BRIDGE_CONTRACT_WRAPPER, bridgeAmount)
              .send({ from: address });

            await waitForTransactionReceipt(wagmiAdapterConfig, {
              confirmation: 1,
              hash: approve.transactionHash,
            });
          }
          break;
        case 'DAI':
          if (BigNumber(bridgeAmount).isGreaterThan(allowance.toString())) {
            const approve = await TokenContract.methods
              .approve(REACT_APP_BRIDGE_CONTRACT_WRAPPER, bridgeAmount)
              .send({ from: address });

            await waitForTransactionReceipt(wagmiAdapterConfig, {
              confirmation: 1,
              hash: approve.transactionHash,
            });
          }
          break;
      }

      if (AppConfig.isDev) {
        const ozkAmount = web3.utils.toWei(1, 'ether');
        const OzkTokenContract = new web3.eth.Contract(
          OZKToken,
          REACT_APP_OZK_TOKEN,
        );

        const approveOzk = await OzkTokenContract.methods
          .approve(REACT_APP_BRIDGE_CONTRACT_WRAPPER, ozkAmount)
          .send({ from: address });

        await waitForTransactionReceipt(wagmiAdapterConfig, {
          confirmation: 1,
          hash: approveOzk.transactionHash,
        });
      }

      try {
        const tx = await callStakeAndBridgeStable(bridgeAmount, web3);

        try {
          await waitForTransactionReceipt(wagmiAdapterConfig, {
            confirmation: 1,
            hash: tx.transactionHash,
          });
        } catch (error) {
          if (error?.shortMessage && error.action) {
            setErrorMessage(error.shortMessage);
            setErrorAction(error.action);
          } else {
            setErrorMessage('Rejected transaction');
            setErrorAction('Stake');
          }
          setIsCompleted(false);
          setBridgeStatus('Error');
          return;
        }

        setTxHash(tx.transactionHash);
        setIsCompleted(true);
        setBridgeStatus('Completed');
        loadL1Balance(address);
      } catch (error) {
        if (error?.shortMessage && error.action) {
          setErrorMessage(error.shortMessage);
          setErrorAction(error.action);
        } else {
          setErrorMessage('Rejected transaction');
          setErrorAction('Stake');
        }
        setIsCompleted(false);
        setBridgeStatus('Error');
      }
    } catch (error) {
      console.log(error);
      if (error?.shortMessage && error.action) {
        setErrorMessage(error.shortMessage);
        setErrorAction(error.action);
      } else {
        setErrorMessage('Rejected transaction');
        setErrorAction('Approve');
      }
      setIsCompleted(false);
      setBridgeStatus('Error');
    }
  };

  const callStakeAndBridgeStable = async (bridgeAmount, web3) => {
    let tx;
    const BridgeWrapperContract = new web3.eth.Contract(
      bridgeWrapper,
      REACT_APP_BRIDGE_CONTRACT_WRAPPER,
    );

    if (AppConfig.isDev) {
      tx = await BridgeWrapperContract.methods
        .stakeAndBridgeStableSepoliaTest(
          selectedToken.contract,
          bridgeAmount,
          AppConfig.l2GasLimitAsParam,
        )
        .send({ from: address });
    } else {
      tx = await BridgeWrapperContract.methods
        .stakeAndBridgeStable(
          selectedToken.contract,
          bridgeAmount,
          AppConfig.l2GasLimitAsParam,
        )
        .send({ from: address, value: web3.utils.toWei('0.005', 'ether') });
    }

    return tx;
  };

  const stakeAndBridgeEth = async (bridgeValue, web3) => {
    const bridgeAmount = web3.utils.toWei(bridgeValue, 'ether');
    try {
      setOpenBridgeModal(true);
      setBridgeStatus('Loading');

      try {
        const tx = await callStakeAndBridgeEth(bridgeAmount, web3);

        try {
          await waitForTransactionReceipt(wagmiAdapterConfig, {
            confirmation: 1,
            hash: tx.transactionHash,
          });
        } catch (error) {
          if (error?.shortMessage && error?.action) {
            setErrorMessage(error.shortMessage);
            setErrorAction(error.action);
          } else {
            setErrorMessage('Rejected transaction');
            setErrorAction('Stake');
          }
          setIsCompleted(false);
          setBridgeStatus('Error');
          return;
        }

        setTxHash(tx.transactionHash);
        setIsCompleted(true);
        setBridgeStatus('Completed');
        loadL1Balance(address);
      } catch (error) {
        if (error?.shortMessage && error?.action) {
          setErrorMessage(error.shortMessage);
          setErrorAction(error.action);
        } else {
          setErrorMessage('Rejected transaction');
          setErrorAction('Stake');
        }
        setIsCompleted(false);
        setBridgeStatus('Error');
      }
    } catch (error) {
      console.log(error);
      if (error?.shortMessage && error?.action) {
        setErrorMessage(error.shortMessage);
        setErrorAction(error.action);
      } else {
        setErrorMessage('Rejected transaction');
        setErrorAction('Stake');
      }
      setIsCompleted(false);
      setBridgeStatus('Error');
    }
  };

  const callStakeAndBridgeEth = async (bridgeAmount, web3) => {
    let tx;
    const BridgeWrapperContract = new web3.eth.Contract(
      bridgeWrapper,
      REACT_APP_BRIDGE_CONTRACT_WRAPPER,
    );
    const OzkTokenContract = new web3.eth.Contract(
      OZKToken,
      REACT_APP_OZK_TOKEN,
    );

    if (AppConfig.isDev) {
      const approveOzk = await OzkTokenContract.methods
        .approve(REACT_APP_BRIDGE_CONTRACT_WRAPPER, bridgeAmount)
        .send({ from: address });

      await waitForTransactionReceipt(wagmiAdapterConfig, {
        confirmation: 1,
        hash: approveOzk.transactionHash,
      });

      tx = await BridgeWrapperContract.methods
        .stakeAndBridgeSepoliaTest(AppConfig.l2GasLimitAsParam, bridgeAmount)
        .send({ from: address });
    } else {
      const gasPrice = await web3.eth.getGasPrice();
      tx = await BridgeWrapperContract.methods
        .stakeAndBridge(AppConfig.l2GasLimitAsParam)
        .send({
          from: address,
          value: bridgeAmount,
          gasLimit: AppConfig.l1GasLimit,
          gasPrice: gasPrice,
        });
    }

    return tx;
  };

  useEffect(() => {
    if (!isConnected || !address || !connections) {
      resetTransactions();
      resetL1Balance();
      resetL2Balance();
      resetWithdrawBalance();
      setBridgeValue('');
      setIsClaim(false);
      setBridgeAmountWithCommission('');
      return;
    }
    if (!isDisabled) {
      loadL1Balance(address);
      loadL2Balance(address);
    }
    if (chainId === REACT_APP_CHAIN_ID) {
      loadL2Transactions(connections);
    }
  }, [
    isConnected,
    address,
    connections,
    chainId,
    isDisabled,
    resetL1Balance,
    resetL2Balance,
    resetWithdrawBalance,
  ]);

  useEffect(() => {
    if (error) {
      toast.warn(error);
    }
  }, [error]);

  useEffect(() => {
    if (isWalletConnect) {
      setWalletConnectModal(true);
    }
  }, [isWalletConnect]);

  const getBalanceByCoin = useCallback(
    (symbol) => {
      switch (symbol) {
        case 'ETH':
          return formatterEth.format(ethBalance);
        case 'DAI':
          return formatter.format(daiBalance);
        case 'USDC':
          return formatter.format(usdcBalance);
        case 'USDT':
          return formatter.format(usdtBalance);
        case 'ozUSD':
          return formatter.format(ozUsdBalance);
        case 'ozETH':
          return formatterEth.format(ozEthBalance);
      }
    },
    [
      ethBalance,
      daiBalance,
      usdcBalance,
      usdtBalance,
      ozEthBalance,
      ozUsdBalance,
    ],
  );

  const getBalanceWithoutGas = useCallback(
    async (balance) => {
      const web3 = new Web3(
        isEthereumL1 ? REACT_APP_ETH_RPC : REACT_APP_OPENZK_RPC,
      );
      const gasPrice = await web3.eth.getGasPrice();
      const gas = BigNumber(
        isEthereumL1 ? AppConfig.l1GasLimit : AppConfig.l2GasLimit,
      ).multipliedBy(BigNumber(gasPrice.toString()));
      const wei = web3.utils.toWei(balance, 'ether');
      const totalInWei = BigNumber(wei).minus(gas).toString();

      if (totalInWei < 0) {
        toast.warn('Not enough balance');
        return;
      }

      return web3.utils.fromWei(totalInWei, 'ether');
    },
    [isEthereumL1],
  );

  const setMaxByCoin = useCallback(
    async (symbol) => {
      switch (symbol) {
        case 'ETH':
          const ethBalanceLocal = await getBalanceWithoutGas(ethBalance);
          if (ethBalanceLocal) {
            const valueWithCommission = BigNumber(ethBalanceLocal).multipliedBy(
              BigNumber(REACT_APP_ETH_PERCENTAGE_COMMISSION),
            );
            setBridgeAmountWithCommission(valueWithCommission.toString());
          }
          return setBridgeValue(ethBalanceLocal);
        case 'DAI':
          const daiValueWithCommission = BigNumber(daiBalance).multipliedBy(
            BigNumber(REACT_APP_DAI_PERCENTAGE_COMMISSION),
          );
          setBridgeAmountWithCommission(daiValueWithCommission.toString());
          return setBridgeValue(daiBalance);
        case 'USDC':
          const usdcValueWithCommission = BigNumber(usdcBalance).multipliedBy(
            BigNumber(REACT_APP_USDT_USDC_PERCENTAGE_COMMISSION),
          );
          setBridgeAmountWithCommission(usdcValueWithCommission.toString());
          return setBridgeValue(usdcBalance);
        case 'USDT':
          const usdtValueWithCommission = BigNumber(usdtBalance).multipliedBy(
            BigNumber(REACT_APP_USDT_USDC_PERCENTAGE_COMMISSION),
          );
          setBridgeAmountWithCommission(usdtValueWithCommission.toString());
          return setBridgeValue(usdtBalance);
        case 'ozUSD':
          setBridgeAmountWithCommission(ozUsdBalance);
          return setBridgeValue(ozUsdBalance);
        case 'ozETH':
          const ozEthBalanceLocal = await getBalanceWithoutGas(ozEthBalance);
          if (ozEthBalanceLocal) {
            const valueWithCommission = BigNumber(
              ozEthBalanceLocal,
            ).multipliedBy(BigNumber(REACT_APP_ETH_PERCENTAGE_COMMISSION));
            setBridgeAmountWithCommission(valueWithCommission.toString());
          }
          return setBridgeValue(ozEthBalanceLocal);
      }
    },
    [
      ethBalance,
      daiBalance,
      usdcBalance,
      usdtBalance,
      ozEthBalance,
      getBalanceWithoutGas,
    ],
  );

  return (
    <>
      <CustomModal
        open={openBridgeModal}
        closebtn={'remove'}
        modalTitle={<h5>Wallet Actions</h5>}
        width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
        modalContent={
          <Grid
            container
            lg={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
              className="p-2 rounded"
              bgcolor={'rgba(0, 0, 0, 0.32)'}
            >
              <Grid className="d-flex">
                <p>
                  {' '}
                  <CiWallet className="text-light mx-2" size={30} />{' '}
                  {walletAction}
                </p>
              </Grid>

              {bridgeStatus === 'Waiting' ? (
                <span style={{ color: '#ffffff' }}>Waiting</span>
              ) : bridgeStatus === 'Loading' ? (
                <span>
                  <CircularProgress
                    fourColor
                    style={{ color: '#FFF' }}
                    size={20}
                  />
                </span>
              ) : bridgeStatus === 'Completed' ? (
                <p>
                  {' '}
                  <IoMdCheckmarkCircleOutline
                    style={{ color: '#FC9D4B' }}
                    size={20}
                  />
                </p>
              ) : (
                <p>
                  <MdOutlineErrorOutline
                    style={{ color: '#FC9D4B' }}
                    size={20}
                  />
                </p>
              )}
            </Grid>

            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
              className="mt-4 w-100 "
            >
              {isCompleted ? (
                <p
                  className="airdrop_paratext mb-3 p-3"
                  style={{
                    border: '1px solid #ffffff',
                    borderRadius: '25px',
                    textAlign: 'center',
                  }}
                >
                  {`${
                    bridgeStatus === 'Error'
                      ? 'Error encountered during contract execution'
                      : isClaim
                        ? 'Claim from bridge initiated'
                        : `${bridgeValue} ${selectedToken?.symbol} bridging ${isEthereumL1 ? 'to' : 'from'} OpenZK initiated`
                  }`}{' '}
                </p>
              ) : (
                bridgeStatus === 'Error' && (
                  <p
                    className="airdrop_paratext mb-3 p-3"
                    style={{
                      border: '1px solid #ffffff',
                      borderRadius: '25px',
                      textAlign: 'center',
                    }}
                  >
                    Error: {`${errorMessage} - action: ${errorAction}`}
                  </p>
                )
              )}{' '}
              {txHash !== '' ? (
                <>
                  <a
                    href={REACT_APP_ETH_TRANSACTION + txHash}
                    target="blank"
                    style={{
                      color: '#fff',
                      width: '70%',
                      marginBottom: '20px',
                    }}
                  >
                    <GradiantButton
                      btnTextColor="#FFF"
                      text={'CHECK ETHERSCAN'}
                      borderColor={'#FC9D4B'}
                      width="100%"
                    />
                  </a>

                  <GradiantButton
                    btnTextColor="#FFF"
                    text={'CLOSE'}
                    borderColor={'#FC9D4B'}
                    width="70%"
                    onClick={() => {
                      {
                        setOpenBridgeModal(false);
                        setBridgeValue('');
                        setBridgeAmountWithCommission('');
                        setTxHash('');
                        setIsCompleted(false);
                        setBridgeStatus('Waiting');
                      }
                    }}
                  />
                </>
              ) : txHashL2 !== '' ? (
                <>
                  <a
                    href={
                      REACT_APP_BLOCK_EXPLORER_OPEN_ZK_URL + 'tx/' + txHashL2
                    }
                    target="blank"
                    style={{
                      color: '#fff',
                      width: '70%',
                      marginBottom: '20px',
                    }}
                  >
                    <GradiantButton
                      btnTextColor="#FFF"
                      text={'CHECK ETHERSCAN'}
                      borderColor={'#FC9D4B'}
                      width="100%"
                    />
                  </a>

                  <GradiantButton
                    btnTextColor="#FFF"
                    text={'CLOSE'}
                    borderColor={'#FC9D4B'}
                    width="70%"
                    onClick={() => {
                      {
                        setOpenBridgeModal(false);
                        setBridgeValue('');
                        setBridgeAmountWithCommission('');
                        setTxHashL2('');
                        setIsCompleted(false);
                        setBridgeStatus('Waiting');
                      }
                    }}
                  />
                </>
              ) : (
                <GradiantButton
                  btnTextColor="#FFF"
                  text={!isCompleted ? 'CLOSE' : 'CHECK ETHERSCAN'}
                  borderColor={'#FC9D4B'}
                  width="100%"
                  onClick={() => {
                    setOpenBridgeModal(false);
                    setTxHash('');
                    setIsCompleted(false);
                    setBridgeStatus('Waiting');
                  }}
                />
              )}
            </Grid>
          </Grid>
        }
      />

      {openWarningModal && (
        <CustomModal
          open={openWarningModal}
          setOpen={setOpenWarningModal}
          modalTitle={<h4></h4>}
          width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
          modalContent={
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'flex-start'}
              justifyContent={'flex-start'}
              className="m-0 p-0"
            >
              <Grid
                item
                className="px-3 w-100"
                lg={12}
                md={12}
                sm={12}
                xs={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Grid
                  item
                  className="mb-3"
                  lg={11}
                  md={11}
                  sm={11}
                  xs={11}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  gap={4}
                >
                  <p className="text-center text-2xl text-white">
                    You will no longer earn Airdrop Points if you withdraw
                  </p>
                  <Grid
                    item
                    className="px-3 py-2"
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'center'}
                    onClick={() => setOpenWarningModal(false)}
                    sx={{
                      background:
                        'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                      borderRadius: '12px',
                      cursor: 'pointer',
                    }}
                  >
                    <p className="m-0 p-0 text-lg">Continue Anyway</p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          }
        />
      )}

      {open && (
        <CustomModal
          open={open}
          setOpen={setOpen}
          modalTitle={<h4>Wallet actions</h4>}
          width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
          modalContent={
            <Grid
              container
              lg={12}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'flex-start'}
              justifyContent={'flex-start'}
              className="m-0 p-0"
            >
              <Grid
                item
                className="px-3 w-100"
                lg={12}
                md={12}
                sm={12}
                xs={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Grid
                  item
                  className="mb-3"
                  lg={11}
                  md={11}
                  sm={11}
                  xs={11}
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  gap={4}
                >
                  <p className="text-center text-xl text-white">
                    Make sure the wallet you're bridging to supports OpenZK
                    Network
                  </p>
                  <p className="text-center text-xl text-white">
                    Check OpenZK Network is supported or is able to be added as
                    a custom network before you bridge or you may lose your
                    crypto.
                  </p>
                  <p className="text-center text-xl text-white">
                    OpenZK Network details are available{' '}
                    <a
                      href="https://docs.openzk.net/using-the-openzk-network"
                      target="_blank"
                      className="text-orange64"
                    >
                      here
                    </a>
                  </p>
                  <Grid
                    item
                    className="px-3 py-2"
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'center'}
                    onClick={() => setOpen(false)}
                    sx={{
                      background:
                        'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                      borderRadius: '12px',
                      cursor: 'pointer',
                    }}
                  >
                    <p className="m-0 p-0 text-lg">Close</p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          }
        />
      )}

      <Grid
        item
        className="w-100"
        lg={12}
        md={12}
        sm={12}
        xs={12}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
      >
        <Grid
          item
          className="BridgeGlassCard px-3 py-2 w-full"
          height={isConnected ? '100%' : '100%'}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Grid
            item
            className="w-100 mt-2"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
              gap={'8px'}
            >
              <div className="flex flex-col flex-[1_0_0] gap-1">
                <p className="BridgeSwapLabel">From</p>
                <Grid
                  item
                  className="md:px-[14px] px-[8px] py-[7px] BridgeInputBg h-[53px]"
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'start'}
                  style={{
                    background: '#28282B',
                    borderTopRightRadius: '14px',
                    borderBottomRightRadius: '14px',
                  }}
                >
                  <p className="BridgeSwapText m-0 p-0">
                    {isEthereumL1 ? L1.text : L2.text}
                  </p>
                  <img
                    src={isEthereumL1 ? L1.icon : L2.icon}
                    alt={isEthereumL1 ? L1.name : L2.name}
                    width={'16px'}
                    height={'16px'}
                    className="ml-1"
                  />
                </Grid>
              </div>

              <div
                className="flex p-[16px] justify-center items-center gap-2.5 rounded-[12px] border border-white/10 bg-[#5773FF] cursor-pointer mt-auto"
                onClick={() => {
                  if (isEthereumL1) {
                    setSelectedToken(TokenL2Options[0]);
                    setOpenWarningModal(true);
                    if (address) {
                      resetTransactions();
                    }
                  } else {
                    if (address) {
                      loadL2Transactions(connections);
                    }
                    setSelectedToken(TokenL1Options[0]);
                  }
                  setIsEthereumL1((prev) => !prev);
                  setBridgeValue('');
                  setBridgeAmountWithCommission('');
                }}
              >
                <img src={DoubleArrow} alt="arrows" />
              </div>
              <div className="flex flex-col flex-[1_0_0] gap-1">
                <p className="BridgeSwapLabel">to</p>
                <Grid
                  item
                  className="md:px-[14px] px-[8px] py-[7px] BridgeInputBg h-[53px]"
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'start'}
                  style={{
                    background: '#28282B',
                    borderTopRightRadius: '14px',
                    borderBottomRightRadius: '14px',
                  }}
                >
                  <p className="BridgeSwapText m-0 p-0">
                    {isEthereumL1 ? L2.text : L1.text}
                  </p>
                  <img
                    src={isEthereumL1 ? L2.icon : L1.icon}
                    alt={isEthereumL1 ? L2.name : L1.name}
                    width={'16px'}
                    height={'16px'}
                    className="ml-1"
                  />
                </Grid>
              </div>
            </Grid>
          </Grid>

          <Grid
            item
            className="w-100 mt-3"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Grid
              item
              className="BridgeInputBg"
              lg={12}
              md={12}
              sm={12}
              xs={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <Grid item className="w-100">
                <input
                  type="number"
                  className="p-2"
                  style={{
                    background: 'transparent',
                    color: '#ffffff',
                    width: '100%',
                    border: '0',
                    borderTopLeftRadius: '12px',
                    borderBottomLeftRadius: '12px',
                  }}
                  placeholder={'Enter Amount'}
                  value={bridgeValue}
                  onChange={(e) => HandleDepositInput(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>

              <Grid
                item
                className="p-2 px-4"
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'center'}
                style={{
                  cursor: 'pointer',
                  background: '#28282B',
                  borderTopRightRadius: '12px',
                  borderBottomRightRadius: '12px',
                }}
                onClick={() => setSelectToken(true)}
              >
                <p className="BridgeInputText m-0 p-0">
                  {' '}
                  {selectedToken?.symbol}{' '}
                </p>{' '}
                <img
                  src={selectedToken?.logo}
                  alt="ETH"
                  width={'25px'}
                  height={'25px'}
                  className="mx-1"
                />{' '}
                <MdOutlineKeyboardArrowDown
                  className="mx-1"
                  size={selectedToken.symbol === 'ETH' ? '35px' : '43px'}
                  style={{ color: '#ffffff' }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            className="w-100 mt-4"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-start'}
          >
            <p className="BridgeInputText m-0 p-0">Balance :</p>
            <p className="ml-2 m-0 p-0" style={{ fontSize: '16px' }}>
              {isConnected ? getBalanceByCoin(selectedToken?.symbol) : '0'}{' '}
            </p>
            <img
              src={selectedToken.logo}
              alt="ETH"
              width={'20px'}
              height={'20px'}
              className="mx-1"
            />
            <Grid
              item
              style={{ cursor: 'pointer' }}
              onClick={() => setMaxByCoin(selectedToken?.symbol)}
            >
              <span
                className="mx-2"
                style={{ fontSize: '14px', color: '#FF9854' }}
              >
                Max
              </span>
            </Grid>
          </Grid>

          <Grid
            item
            className="BridgeTextBg p-3 w-full mt-3"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <p className=" m-0 p-0">
              You will receive{' '}
              {bridgeAmountWithCommission !== ''
                ? `~${formatterEth.format(bridgeAmountWithCommission)}`
                : '0.00'}{' '}
              {selectedToken.receiveToken}
            </p>

            <p className="mt-1 m-0 p-0" style={{ color: '#E5772E' }}>
              Staking Rewards + Airdrop Points.
            </p>
          </Grid>
        </Grid>
      </Grid>

      {isEthereumL1 && (
        <Grid
          item
          lg={12}
          md={12}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          className="w-full"
        >
          <p className="text-center ">
            Bridging from Ethereum to OpenZK may take up to 60 minutes
          </p>{' '}
        </Grid>
      )}

      <Grid
        container
        className="mt-0 w-100"
        xs={12}
        gap="20px"
        display={'flex'}
        flexDirection={'row'}
        alignItems={'center'}
        alignContent={'center'}
        justifyContent={'center'}
      >
        <Grid
          item
          xs={12}
          className="mt-2 w-100"
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          {!isConnected ? (
            <ConnectButton />
          ) : chain?.id !== REACT_APP_CHAIN_ID && isEthereumL1 ? (
            <Button
              className="mr-2"
              sx={{
                height: '40px',
                width: 'auto',
                backgroundColor: '#000000',
                border: 0.75,
                borderColor: '#FC9D4B',
                borderRadius: '10px',
                color: '#FFE584',
                fontWeight: 'semibold',
                fontFamily: 'PoppinsRegular',
                boxShadow: '0px 0px 13px 1px #FC9D4B',
                fontSize: {
                  xs: '10px', // For extra small screens (mobile)
                  sm: '16px', // For small screens (tablets)
                  md: '18px', // For medium screens
                  lg: '18px', // For large screens
                },
                padding: {
                  xs: '15px', // For extra small screens
                  sm: '12px', // For small screens
                  md: '15px', // For medium screens
                },
                '&:hover': {
                  background:
                    'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                  color: '#ffffff',
                },
                textTransform: 'none',
              }}
              onClick={() => {
                !isDisabled && !isWalletConnect && addEthereumChain();
              }}
            >
              {`Switch ${isWalletConnect ? 'your browser & wallet' : ''} to ${AppConfig.isDev ? 'Sepolia Testnet' : 'Ethereum Mainnet'}`}
            </Button>
          ) : chain.id !== REACT_APP_OPENZK_CHAIN_ID && !isEthereumL1 ? (
            <Button
              className="mt-2"
              sx={{
                height: '40px',
                width: 'auto',
                backgroundColor: '#000000',
                border: 0.75,
                borderColor: '#FC9D4B',
                borderRadius: '10px',
                color: '#FFE584',
                fontWeight: 'semibold',
                fontFamily: 'PoppinsRegular',
                boxShadow: '0px 0px 13px 1px #FC9D4B',
                fontSize: {
                  xs: '10px', // For extra small screens (mobile)
                  sm: '16px', // For small screens (tablets)
                  md: '18px', // For medium screens
                  lg: '18px', // For large screens
                },
                padding: {
                  xs: '15px', // For extra small screens
                  sm: '12px', // For small screens
                  md: '15px', // For medium screens
                },
                '&:hover': {
                  background:
                    'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                  color: '#ffffff',
                },
                textTransform: 'none',
              }}
              onClick={() => {
                !isDisabled && !isWalletConnect && addOZKChain();
              }}
            >
              {`Switch ${isWalletConnect ? 'your browser & wallet' : ''} to OpenZK Network`}
            </Button>
          ) : (
            <Button
              className="mt-2"
              sx={{
                height: '40px',
                width: 'auto',
                backgroundColor: '#000000',
                border: 0.75,
                borderColor: '#FC9D4B',
                borderRadius: '10px',
                color: '#FFE584',
                fontWeight: 'semibold',
                fontFamily: 'PoppinsRegular',
                boxShadow: '0px 0px 13px 1px #FC9D4B',
                fontSize: {
                  xs: '10px', // For extra small screens (mobile)
                  sm: '16px', // For small screens (tablets)
                  md: '18px', // For medium screens
                  lg: '18px', // For large screens
                },
                padding: {
                  xs: '15px', // For extra small screens
                  sm: '12px', // For small screens
                  md: '15px', // For medium screens
                },
                '&:hover': {
                  background:
                    'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                  color: '#ffffff',
                },
                textTransform: 'none',
              }}
              onClick={() => {
                if (!isDisabled) {
                  if (isEthereumL1) {
                    handleBridgeL1Token();
                  } else {
                    handleBridgeL2Token();
                  }
                }
              }}
            >
              {isEthereumL1 ? 'Stake & Bridge' : 'Bridge'}
            </Button>
          )}
        </Grid>

        <Grid
          item
          height={'100%'}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'start'}
          className="BridgeGlassCard p-3 mt-4"
        >
          {isEthereumL1 ? (
            loading ? (
              <CircularProgress fourColor style={{ color: '#FFF' }} size={20} />
            ) : transactions?.length === 0 ? (
              <p className="text-center text-white text-lg">
                No Pending L2 to L1 Transactions!
              </p>
            ) : (
              <Grid
                item
                display={'flex'}
                flexDirection={'column'}
                className="gap-4 w-full"
              >
                <p className="text-white text-start text-2xl font-normal">
                  Pending L2 to L1 Transactions
                </p>
                <Grid
                  item
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                  justifyContent={'start'}
                  className="w-full gap-2"
                >
                  {transactions.map((hash, index) => {
                    return (
                      <Grid
                        item
                        key={index}
                        display={'flex'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        className="text-white w-full"
                      >
                        <Grid
                          item
                          display={'flex'}
                          alignItems={'center'}
                          className="gap-2"
                        >
                          <CircularProgress
                            fourColor
                            style={{ color: '#FFF' }}
                            size={20}
                          />
                          {hash.description}
                        </Grid>
                        <Grid
                          className="cursor-pointer px-4 py-2 bg-[#5773ff] rounded-[20px]"
                          onClick={() =>
                            hash.status === Status.claim &&
                            finalizeWithdrawal(hash.txHash)
                          }
                        >
                          <p className="text-center">
                            {hash.status === Status.pending
                              ? 'Pending'
                              : 'Claim'}
                          </p>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            )
          ) : (
            <p className="text-center text-white text-lg">
              To See L2 to L1 Transactions Status Switch to Ethereum Mainnet
            </p>
          )}
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          {' '}
          <p style={{ textAlign: 'center' }} id="agreeTcId">
            {' '}
            <Checkbox
              style={{ color: 'green' }}
              checked={isChecked}
              onClick={handleCheckboxChange}
            />{' '}
            Agree to our{' '}
            <a
              href="/pdf/OpenZK_Terms.of.Use_250620.pdf"
              target="_blank"
              className="landingPtag"
            >
              {' '}
              Terms and Conditions of Use{' '}
            </a>{' '}
            and our{' '}
            <a href="/privacypolicy" target="_blank" className="landingPtag">
              Privacy Policy.{' '}
            </a>
          </p>{' '}
        </Grid>
      </Grid>

      <WalletConnectModal
        open={walletConnectModal}
        close={() => setWalletConnectModal(false)}
      />

      <CustomModal
        open={selectToken}
        setOpen={setSelectToken}
        modalTitle={<h4>Select Tokens</h4>}
        width={{ lg: '30%', md: '30%', xs: '90%', sm: '90%' }}
        modalContent={
          <Grid
            container
            lg={12}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'flex-start'}
            className="m-0 p-0"
          >
            <Grid
              item
              className="px-3 w-100"
              lg={12}
              md={12}
              sm={12}
              xs={12}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Grid
                item
                className="mb-3"
                lg={11}
                md={11}
                sm={11}
                xs={11}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
              >
                {TokenOptions && TokenOptions?.length > 0
                  ? TokenOptions.map((itm, i) => {
                      return (
                        <Grid
                          item
                          key={i}
                          className="w-100 p-3 mt-2"
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          display={'flex'}
                          flexDirection={'row'}
                          alignItems={'flex-start'}
                          justifyContent={'space-between'}
                          style={{
                            background: '#FFFFFF0F',
                            borderRadius: '15px',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            handleSelectDepositToken(itm);
                          }}
                        >
                          <Grid
                            item
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                          >
                            <img
                              src={itm?.logo}
                              alt="tokenlogo"
                              width={'30px'}
                              height={'30px'}
                              className="mx-2"
                            />
                            <p className="airdrop_text">{itm?.Token}</p>
                          </Grid>
                          <p className="airdrop_text">
                            {isConnected ? getBalanceByCoin(itm.symbol) : '0'}
                          </p>
                        </Grid>
                      );
                    })
                  : ''}
              </Grid>
            </Grid>
          </Grid>
        }
      />
    </>
  );
};

export default Bridge;
